import { Dimensions } from 'react-native';
import { Breakpoint, getBreakpoint, Image } from '@bonanza-social/moonlight';
import { PrizeWallImageSet } from '../state/prizeWall/prizeWall.types';
import images from '../assets/images';

export const prefetchImages = (images: PrizeWallImageSet[]) => {
  const breakpoint = getBreakpoint(Dimensions.get('window').width);
  const imageUrls = images.map((image) =>
    breakpoint === Breakpoint.MOBILE ? image.mobileUrl : image.desktopUrl,
  );

  Image.prefetch(imageUrls);
};

export const prefetchLocalImages = () => {
  Object.values(images).forEach((image) => {
    Image.loadAsync(image);
  });
};
